import { ROLES_SELECT } from 'core/utils/user';
import React from 'react';

import Button from 'core/modules/atoms/Button';
import { InputCheckbox } from 'ui';
import SelectCustomizable from 'core/modules/atoms/SelectCustomizable';
import InputText from 'ui/atoms/InputText/InputText';
import FormField from 'ui/molecules/form-field/FormField';

const SignupForm = () => {
  // deprecated

  return (
    <div className="login-form">
      <div className="login-form__item">
        <h3 className="login-form__title">Sign Up</h3>
      </div>
      <div className="login-form__item">
        <FormField label="User">
          <InputText />
        </FormField>
      </div>
      <div className="login-form__item">
        <FormField label="Email">
          <InputText />
        </FormField>
      </div>
      <div className="login-form__item">
        <FormField label="Password">
          <InputText type="password" />
        </FormField>
      </div>
      <div className="login-form__item">
        <FormField label="Repeat password">
          <InputText type="password" />
        </FormField>
      </div>
      <div className="login-form__item">
        <SelectCustomizable label="Rol" type="password" options={ROLES_SELECT} />
      </div>
      <div className="login-form__item">
        <div className="login-form__checkbox-container">
          <InputCheckbox label="Accept terms and conditions of use" />
        </div>
        <Button text="Sign Up" />
      </div>
      <div className="login-form__item">
        <span className="login-form__text">
          If you already have an account, <span className="login-form__link">login here</span>
        </span>
      </div>
    </div>
  );
};

export default SignupForm;
